import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const STATS = [
  { value: "150+", label: "Tamamlanan Proje" },
  { value: "120+", label: "Mutlu Müşteri" },
  { value: "%98", label: "Müşteri Memnuniyeti" },
  { value: "7/24", label: "Teknik Destek" },
];

const VALUES = [
  "Sektör odaklı strateji",
  "Veri odaklı kararlar",
  "Şeffaf raporlama",
  "Sürekli optimizasyon",
];

export default function About() {
  return (
    <section
      id="hakkimizda"
      data-testid="about-section"
      className="relative py-24 sm:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          {/* Left text */}
          <div className="lg:col-span-6">
            <span className="ab-chip">Hakkımızda</span>
            <h2 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[var(--ab-navy)] leading-[1.05]">
              Dijitaldeki
              <br />
              <span className="ab-text-gradient">güvenilir</span> iş ortağınız.
            </h2>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              <strong>AjansBilir</strong> olarak işletmelerin dijital
              dünyadaki potansiyellerini tam anlamıyla kullanmalarını
              sağlıyoruz. Modern tasarımlar, veri odaklı reklam stratejileri ve
              hayatı kolaylaştıran otomasyonlarla yanınızdayız.
            </p>

            <ul className="mt-7 grid sm:grid-cols-2 gap-3">
              {VALUES.map((v) => (
                <li
                  key={v}
                  className="flex items-center gap-2.5 text-[var(--ab-navy)] font-medium"
                >
                  <CheckCircle2 className="h-5 w-5 text-[var(--ab-blue)] shrink-0" />
                  {v}
                </li>
              ))}
            </ul>

            <div className="mt-10 grid grid-cols-2 gap-4">
              {STATS.map((s, i) => (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="rounded-2xl border border-slate-200 bg-[var(--ab-bg-soft)] p-5"
                  data-testid={`about-stat-${i}`}
                >
                  <div className="font-display text-3xl sm:text-4xl font-extrabold ab-text-gradient">
                    {s.value}
                  </div>
                  <div className="text-sm text-slate-600 mt-1">{s.label}</div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Right image */}
          <div className="lg:col-span-6">
            <div className="relative">
              <div
                className="absolute -inset-4 rounded-[2rem] blur-2xl opacity-30"
                style={{
                  background:
                    "linear-gradient(135deg, #2D3FFF, #5A3FFF)",
                }}
                aria-hidden
              />
              <div className="relative rounded-3xl overflow-hidden border border-slate-200 shadow-[0_30px_70px_-30px_rgba(10,19,48,0.30)]">
                <img
                  src="https://images.pexels.com/photos/7108269/pexels-photo-7108269.jpeg"
                  alt="AjansBilir ekibi çalışırken"
                  loading="lazy"
                  className="w-full h-full object-cover aspect-[4/5]"
                />
              </div>

              <motion.div
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="absolute -bottom-6 -right-4 sm:right-8 bg-white rounded-2xl border border-slate-200 shadow-xl px-5 py-4 max-w-[260px]"
              >
                <div className="text-xs uppercase tracking-widest text-slate-500">
                  Misyon
                </div>
                <div className="font-display font-semibold text-[var(--ab-navy)] mt-1 text-sm leading-snug">
                  İşletmelerin dijitalde rakipsiz olmasını sağlamak.
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
